import AppStatusBadge from "./StatusBadge.vue";

export default {
    AppStatusBadge,
};
